import { render } from "./OrderBilling.vue?vue&type=template&id=74de37a0"
import script from "./OrderBilling.vue?vue&type=script&lang=js"
export * from "./OrderBilling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__